<template>
	<div id="search">
		<div class="container">
			<div class="search-index ">
				<input @keyup.13="getdata(search)" v-model="search" placeholder="请输入需要搜索的内容" class="search-input2 input-xlarge search-query"
				 type="text">
				<div class="search-xg-sty">
					<input type="button" @click="getdata" class="search-btn3" />
					<div class="search-btn-xg"><i></i></div>

				</div>
			</div>
			<div class="clearfix"></div>

		</div>
		<!-- 艺人百科 -->
		<div class="container index-con">

			<div class="index-con-tit">
				<div class="index-con-wd bk">
					<h2>艺人百科</h2>
					<i></i>

					<h4>ARTIST ENCYCLOPEDIA INTRODUCTION</h4>

				</div>
				<div class="index-con-more">
					<router-link to='/baikelist'>More</router-link>
				</div>
				<div class="clearfix"></div>
			</div>

			<div class="index-list">
				<ul>
					<li v-for="item in list.actor" :key="item.id">
						<router-link :to="'/baikecontent/'+item.id">
							<img class="index-list-img" width="100%" height="auto" v-bind:src="item.picture" v-bind:alt="item.name" />

							<div class="bk-txt">
								<p style="margin-top: 30px;">姓名：{{item.name}}</p>
								<p>性别：{{item.sex}}</p>
								<p>年龄：{{item.age}}</p>
								<p>身高：{{item.stature}}</p>
								<p class="index-pic-p">座右铭：{{item.signature}}</p>
								<div class="bk-list"><i></i></div>
							</div>
						</router-link>
					</li>

					<div class="clearfix"></div>
				</ul>
			</div>



		</div>
		<!-- 剧组资讯 -->
		<div class="container  index-con">
			<div class="index-con-tit">
				<div class="index-con-wd jz">
					<h2>剧组资讯</h2>
					<i></i>

					<h4>FILM CREW CONSULTATION</h4>

				</div>
				<div class="index-con-more">
					<router-link to='/juzu'>More</router-link>
				</div>
				<div class="clearfix"></div>
			</div>
			<ul>

				<li style="margin-top: 20px;" class="jz-con-infor" v-for="item in list.crew" :key="item.id">
					<router-link :to="'/juzucontent/'+item.id">
						<img style="float: left;" v-bind:src="item.picture" width="250" height="350">

						<div class="jz-con-wd float-left">
							<div style="height: 290px;">
								<p>作品名称：{{item.movie_name}}</p>
								<p>作品类型：{{item.theme}}</p>
								<p>出品方：{{item.make}}</p>
								<p>筹备地点：{{item.prepare}}</p>
								<p>开机时间：{{item.start_time}}</p>
								<p>暂定拍摄地点：{{item.take_place}}</p>
								<p>暂定拍摄周期：{{item.take_period}}</p>
								<p>作品简介：{{item.synopsis}}</p>
							</div>
							<div style="height: 60px;"><a class="float-left list-more" href="">了解更多</a></div>
						</div>

						<div class="clearfix"></div>
					</router-link>
				</li>

			</ul>
			<div class="clearfix"></div>

		</div>
		<!-- 热点观察 -->
		<div class="container  index-con">
			<div class="index-con-tit">
				<div class="index-con-wd hot">
					<h2>热点观察</h2>
					<i></i>

					<h4>HOT SPOT BOOBSERVATION</h4>

				</div>
				<div class="index-con-more">
					<router-link to='/hotlist'>More</router-link>
				</div>
				<div class="clearfix"></div>
			</div>
			<ul>
				<li class="rd-con" v-for="item in list.essay" :key="item.id">
					<router-link :to="'/hotcontent/'+item.id">
						<img width="100%" height="auto" v-bind:src="item.picture" v-bind:alt="item.name" />
						<p>{{item.title}}</p>
					</router-link>
				</li>
				<div class="clearfix"></div>
			</ul>
		</div>
		<!-- 映派专访 -->
		<div class="container  index-con">
			<div class="index-con-tit">
				<div class="index-con-wd zf">
					<h2>映派专访</h2>
					<i></i>

					<h4>YINGPAI INTERVIEW</h4>

				</div>
				<div class="index-con-more">
					<router-link to='/videolist'>More</router-link>
				</div>
				<div class="clearfix"></div>
			</div>
			<ul>
				<li class="zf-con-list" v-for="item in list.yopoo" :key="item.id">
					<router-link :to="'/videocontent/'+item.id">
						<img width="100%" height="auto" v-bind:src="item.picture" v-bind:alt="item.name">

						<div class="zf-con-txt">
							<h3>{{item.title}}</h3>
							<p>{{item.intro}}</p>
						</div>
					</router-link>
				</li>
				<div class="clearfix"></div>
			</ul>
		</div>
	</div>


</template>

<script>
	import storage from '../storage/storage.js'
	export default {
		name: 'home',
		data() {
			return {
				list: [],
				search: []
			}
		},
		methods: {
			autodata() {
				var autosearch = storage.get('search')
				var api = 'http://api.yopoo.cn/api/v1/homesearch?page=1&count=6' + '&search=' + autosearch
				this.$http.get(api).then((res) => {
					this.list = res.body

					if (this.list.actor == '' && this.list.crew == '' && this.list.essay == '' && this.list.yopoo == '') {
						this.$message({
							message: '没有相关数据',
							type: 'warning',
							center: true
						});
					}
					storage.del('search')
				})
			},
			getdata() {
				if (this.search == '') {
					this.$message({
						message: '请输入搜索内容!',
						type: 'warning',
						center: true

					});

				} else {
					var api = 'http://api.yopoo.cn/api/v1/homesearch?page=1&count=6' + '&search=' + this.search
					this.$http.get(api).then((res) => {

						this.list = res.body
						if (this.list.actor == '' && this.list.crew == '' && this.list.essay == '' && this.list.yopoo == '') {
							this.$message({
								message: '没有相关数据',
								type: 'warning',
								center: true

							});
						}
					})

				}
			}
		},
		mounted() {

			this.autodata()
		}

	}
</script>
<style>
	#search {
		background-image: url(https://yopoo.oss-cn-beijing.aliyuncs.com/bg.jpg);
			background-size: 100% auto;
		background-repeat: no-repeat;
		background-attachment: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -1;

		padding-top: 230px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue